<template>
  <div class="desktop-painting-detail" v-resize="onResize" ref="component">
    <div
      v-if="ancestors.length"
      :class="['desktop-painting-detail-bg']"
      :style="{
        top: setTop(ancestors[ancestors.length - 1]) + 'px',
        height: setHeight(ancestors[ancestors.length - 1]) + 'px'
      }"
    ></div>
    <div class="desktop-painting-detail__close" @click="close()">
      <svgicon
        class="icon-close"
        icon="icon-close"
        width="13"
        height="13"
      ></svgicon>
    </div>
    <div class="desktop-painting-detail__image-container">
      <div class="desktop-painting-detail__image-container-wrapper">
        <div
          class="desktop-painting-detail__image-container__disclaimer"
          v-if="info.downloaded === 'true (look S)'"
        >
          <svgicon
            class="icon-eye-slashed"
            icon="icon-eye-slashed"
            width="31"
            height="31"
          ></svgicon>
          <span>{{ content.rights_disclaimer }}</span>
        </div>
        <img
          :src="
            `${assetsPaths.imagesPath}${$tvaMq === 'mobile' ? '500' : '1280'}/${
              info.id
            }.jpg`
          "
        />
      </div>
    </div>
    <div class="desktop-painting-detail__details">
      <div class="info__year">{{ info.anno }}</div>
      <div class="info__name">{{ info.titolo_opera }}</div>
      <div class="info__author">{{ info.autore }}</div>
      <div class="info__place">
        {{ formattedInfoPlace }}
      </div>
      <a
        v-if="info['link.opera1(collection)']"
        class="info__link"
        :href="info['link.opera1(collection)']"
        target="_blank"
        >{{ content.details.link }}
        <svgicon
          class="icon-external-link"
          icon="icon-external-link"
          width="12"
          height="12"
        ></svgicon
      ></a>
      <div class="info__rights">
        {{ content.details.rights }}
      </div>
    </div>
    <div
      class="desktop-painting-detail__related"
      v-if="relatedPaintings.length > 0"
    >
      <div class="desktop-painting-detail__related__other">
        <div class="more">{{ content.details.more }}</div>
        <div clasS="author">{{ info.autore }}</div>
      </div>
      <div
        class="desktop-painting-detail__related__container"
        id="scroll-container"
      >
        <div
          v-for="el in relatedPaintings"
          :key="el.id"
          class="related-card"
          @click="relatedCardClick(el)"
        >
          <div
            class="related-card__sliding-img"
            :style="{
              backgroundImage: `url(${assetsPaths.imagesPath}${
                $tvaMq === 'mobile' ? '500' : '1280'
              }/${el.id}.jpg)`
            }"
          ></div>
          <div class="related-card__text-container">
            <div class="title">{{ truncateString(el.titolo_opera, 28) }}</div>
            <div class="canto">{{ cantiche[el.id.split("-")[0]] }}</div>
            <div class="canto">{{ content.details.canto }} {{ el.canto }}</div>
            <div class="scene">{{ truncateString(el.scena, 30) }}</div>
          </div>
        </div>
      </div>
      <svgicon
        class="icon-arrow-down-big"
        icon="icon-arrow-down-big"
        width="10"
        height="145"
        @click="scrollDown()"
      ></svgicon>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import "../../compiled-icons/icon-close";
import "../../compiled-icons/icon-external-link";
import _ from "lodash";
import assetsPaths from "@/assets/assetsPaths.js";
import { truncateString } from "@/utilities/functions/stringUtils";
import * as d3Scale from "d3-scale";
import resize from "vue-resize-directive";
import "@/compiled-icons/icon-arrow-down-big";

export default {
  data() {
    return {
      width: 0,
      height: 0,
      assetsPaths,
      scrollableHeight: 200,
      baseUrl: process.env.BASE_URL,
      cantiche: {
        1: "Inferno",
        2: "Purgatorio",
        3: "Paradiso"
      }
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.setDimensions();
    });
  },
  computed: {
    ancestors() {
      if (!this.getVizElSelected) {
        return [];
      } else {
        let res = this.getVizElSelected.ancestors();
        return res.reverse().slice(1, res.length - 1);
      }
    },
    relatedPaintings() {
      return _.uniqBy(
        this.getAuthors[this.info.autore].filter(el => el.id !== this.info.id),
        "id"
      );
    },
    content() {
      return this.$ml.get("gallery");
    },
    formattedInfoPlace() {
      const info = [
        this.info.gallery_library_archive_museum,
        this.info.city,
        this.info.country
      ]
        .filter(Boolean)
        .join(", ");

      return info;
    },
    ...mapGetters([
      "getAuthors",
      "getFilterViz",
      "hierarchyData",
      "getVizElSelected"
    ])
  },
  props: ["info"],
  methods: {
    setTop(el) {
      let min = el.data.progress[this.getFilterViz];
      let max =
        el.data.progress[this.getFilterViz] + el.data.weight[this.getFilterViz];

      let scale = d3Scale
        .scaleLinear()
        .domain([min, max])
        .range([0, this.height]);
      return scale(0);
    },
    setHeight(el) {
      let max = el.data.weight[this.getFilterViz];
      let scale = d3Scale
        .scaleLinear()
        .domain([0, max])
        .range([0, this.height]);
      return scale(this.hierarchyData.data.weight[this.getFilterViz]);
    },
    close() {
      this.$emit("close");
    },
    relatedCardClick(el) {
      this.$emit("relatedClick", el);
    },
    setDimensions() {
      const component = this.$refs.component;
      this.width = component.getBoundingClientRect().width;
      this.height = component.getBoundingClientRect().height;
    },
    onResize() {
      this.setDimensions();
    },
    scrollDown() {
      const el = document.getElementById("scroll-container");
      const height = el.scrollHeight;
      this.scrollableHeight = this.scrollableHeight + 200;
      if (this.scrollableHeight < height - 200) {
        el.scroll({
          top: this.scrollableHeight,
          left: 0,
          behavior: "smooth"
        });
      }
    },
    truncateString
  },
  directives: {
    resize
  }
};
</script>
<style lang="scss" scoped>
.desktop-painting-detail {
  height: 100vh;
  width: 100vw;
  left: 0;
  position: fixed;
  z-index: $z-f;
  display: flex;
  flex-direction: row;
  &-bg {
    position: absolute;
    width: 100%;
    top: 0;
    height: 100vh;
    left: 0;
    z-index: $z-none;

    background: linear-gradient(
      180deg,
      #96c2c4 -3.84%,
      #bea95e 49.07%,
      #573c46 106.58%
    );
  }
  &__close {
    width: 35px;
    height: 35px;
    background-color: white;
    cursor: pointer;
    position: absolute;
    top: 35px;
    left: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 2;
    .icon-close {
      fill: rgba(0, 0, 0, 0.7);
      transition: fill 0.2s;
    }
    &:hover {
      fill: rgba(0, 0, 0, 1);
    }
  }
  &__image-container {
    height: 100%;
    width: 100vh;
    border-right: 1px solid $white-30;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1;

    &-wrapper {
      position: relative;
      width: 70%;
    }
    img {
      width: 100%;
    }
    &__disclaimer {
      position: absolute;
      top: calc(50% - 40px);
      left: 0;
      width: 80%;
      margin: 0 10%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      @include pM;
      .icon-eye-slashed {
        fill: none;
        stroke: $white;
      }
      span {
        text-shadow: 0px 0px 3px rgba(0, 0, 0, 0.5);
        text-align: center;
      }
    }
  }
  &__details {
    width: calc(100vw - 100vh - 240px);
    padding: 0 70px 0 50px;
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: center;
    position: relative;
    .info {
      &__year {
        color: $white;
        @include HighlightS;
        margin-bottom: 30px;
      }
      &__name {
        color: $white;
        @include HH3;
        margin-bottom: 30px;
      }
      &__author {
        color: $white;
        @include HH4;
        margin-bottom: 30px;
      }
      &__place {
        color: $white;
        @include pS;
        margin-bottom: 30px;
      }
      &__link {
        @include ButtonS;
        color: $white;
        border-bottom: 1px solid $white;
        width: fit-content;
        .icon-external-link {
          fill: $white;
          margin-left: 9px;
        }
      }
      &__rights {
        color: $white;
        @include DidaS;
        font-size: 9px;
        position: absolute;
        bottom: 50px;
        max-width: 200px;
      }
    }
  }
  &__related {
    width: 240px;
    height: 100%;
    z-index: 1;
    border-left: 1px solid $white-30;
    position: relative;
    .icon-arrow-down-big {
      position: fixed;
      bottom: 40px;
      right: 30px;
      z-index: 1000;
      cursor: pointer;
      fill: $white;
      transition: transform 0.3s ease;
      pointer-events: all;
      &:hover {
        transform: translateY(20px);
      }
    }
    &__other {
      width: 100%;
      height: 90px;
      padding: 0 40px 0 25px;
      border-bottom: 1px solid $white-30;
      display: flex;
      flex-direction: column;
      justify-content: center;
      .more {
        @include DidaL;
      }
      .author {
        @include HH4;
      }
    }
    &__container {
      height: calc(100% - 90px);
      width: 100%;
      overflow: auto;
      &::-webkit-scrollbar {
        width: 8px;
      }
      &::-webkit-scrollbar-track {
        background: rgba(255, 255, 255, 0.3);
      }
      &::-webkit-scrollbar-thumb {
        background: rgba(255, 255, 255, 1);
      }
      .related-card {
        width: 100%;
        height: 190px;
        border-bottom: 1px solid $white-30;
        position: relative;
        cursor: pointer;
        overflow: hidden;
        &__sliding-img {
          height: 100%;
          width: 100%;
          position: absolute;
          z-index: $z-c;
          right: -70%;
          transition: all 0.5s ease-in-out;
          background-position: center; /* Center the image */
          background-repeat: no-repeat; /* Do not repeat the image */
          background-size: cover; /* Resize the background image to cover the entire container */
          &::after {
            content: "";
            height: 100%;
            width: 100%;
            position: absolute;
            background-image: linear-gradient(
              to top,
              rgba(0, 0, 0, 0.7),
              rgba(0, 0, 0, 0.2)
            );
            z-index: $z-d;
          }
        }
        &:hover {
          .related-card__sliding-img {
            right: 0;
          }
          .related-card__text-container {
            .canto,
            .scene {
              opacity: 1;
            }
          }
        }
        &__text-container {
          padding: 0 80px 0 25px;
          display: flex;
          flex-direction: column;
          height: 100%;
          justify-content: center;
          position: absolute;
          z-index: $z-e;
          .title {
            @include HH4;
            margin-bottom: 10px;
          }
          .canto,
          .scene {
            color: $white;
            @include DidaM;
            opacity: 0.7;
            transition: opacity 0.2s;
          }
        }
      }
    }
  }
}
</style>
